import styled from 'styled-components';

export const NewBorderStyle = styled.div`
  border-bottom: 1px solid #dddddd;
  margin: 10px -15px;
`;
